import { render, staticRenderFns } from "./DataAnalysisDashboardGruppiPage.vue?vue&type=template&id=0986fa0e"
import script from "./DataAnalysisDashboardGruppiPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardGruppiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports